var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIndent02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25001H3M12 4.00001L3 4.00001M21 14.75H3M21 20H3M19.72 2.96001L15.8533 5.86001C15.5638 6.07713 15.4191 6.18569 15.3673 6.31878C15.322 6.43535 15.322 6.56468 15.3673 6.68125C15.4191 6.81434 15.5638 6.9229 15.8533 7.14001L19.72 10.04C20.132 10.349 20.338 10.5035 20.5104 10.4999C20.6604 10.4968 20.8012 10.4264 20.8937 10.3083C21 10.1725 21 9.91499 21 9.40001V3.60001C21 3.08504 21 2.82755 20.8937 2.69176C20.8012 2.5736 20.6604 2.50324 20.5104 2.50012C20.338 2.49654 20.132 2.65103 19.72 2.96001Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIndent02);
export default __webpack_public_path__ + "static/media/right-indent-02.529b64b015973b20f4b83e56802a4a62.svg";
export { ForwardRef as ReactComponent };